/**
 * @generated SignedSource<<fd10dbcf9f26bbb554ca11c42d5abace>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type twoSectionTopWidgetQueue$data = {
  readonly variantTwoItems: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly " $fragmentSpreads": FragmentRefs<"entityLink" | "homeSecondaryContentItemContent" | "sectionTopLeadSecondaryContentItemContent">;
      };
    }>;
  } | null | undefined;
  readonly " $fragmentType": "twoSectionTopWidgetQueue";
};
export type twoSectionTopWidgetQueue$key = {
  readonly " $data"?: twoSectionTopWidgetQueue$data;
  readonly " $fragmentSpreads": FragmentRefs<"twoSectionTopWidgetQueue">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "excludeEntityIds"
    },
    {
      "defaultValue": 5,
      "kind": "LocalArgument",
      "name": "first"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "twoSectionTopWidgetQueue",
  "selections": [
    {
      "alias": "variantTwoItems",
      "args": [
        {
          "fields": [
            {
              "kind": "Variable",
              "name": "entityIds",
              "variableName": "excludeEntityIds"
            }
          ],
          "kind": "ObjectValue",
          "name": "exclude"
        },
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        }
      ],
      "concreteType": "QueueItemConnection",
      "kind": "LinkedField",
      "name": "items",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "QueueItemsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": null,
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "InlineFragment",
                  "selections": [
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "entityLink"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "homeSecondaryContentItemContent"
                    },
                    {
                      "args": null,
                      "kind": "FragmentSpread",
                      "name": "sectionTopLeadSecondaryContentItemContent"
                    }
                  ],
                  "type": "Content",
                  "abstractKey": "__isContent"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Queue",
  "abstractKey": null
};

(node as any).hash = "3c763b11a4928c4a92c8d59ec1dd70ac";

export default node;
